import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.css'],
})
export class CommonModalComponent implements OnInit {
  @Input() imgSrc: string = '';
  @Input() imgClass: string = 'img-50'; //Use ng-deep if imgClass is not working.
  @Input() imgAltName: string = '';
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() leftBtnText: string = '';
  @Input() rightBtnText: string = '';
  @Input() onRightBtnClick: () => void;
  @Input() onLeftBtnClick: () => void;


  ngOnInit() {}

  handleRightBtnClick(): void {
    // Call the parent's callback
    this.onRightBtnClick();
  }

  handleLeftBtnClick(): void {
    // Call the parent's callback
    this.onLeftBtnClick();
  }
}
